import React, { Component } from 'react';
import {connect} from 'react-redux';
import __ from 'lodash';
import {cekCookies} from '../../../../actions';
import axios from 'axios';
import { CONFIG } from '../../../../config';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import { Row, Col } from 'react-bootstrap';
import LoaderModal from '../../../modal/LoaderModal';
import accountManagement from '../../../../apis/accountManagement';

import Loader from '../../../Loader';
class ResetUsername extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            loading: false,
            username : null,
            dataSiswa : [],
            message : null
        }
    }

    async componentDidMount() {
        document.title = "Reset Username";
        this.setState({
            isFetching: true
        });
        await this.props.cekCookies();

        if(!__.isEmpty(this.props.account)) {
        }
        
        window.$("#sidebar").mCustomScrollbar({
            theme: "minimal"
        });

        window.$('#sidebarCollapse').on('click', function () {
            window.$('#sidebar, #content').toggleClass('active');
            window.$('.collapse.in').toggleClass('in');
            window.$('a[aria-expanded=true]').attr('aria-expanded', 'false');
        });

        this.setState({
            isFetching: false
        });
    }

    inputUsernameOnChange = async (kode) =>{
        this.setState({username: kode.target.value})
    }

    
    cariSiswa = async ()=>{
        this.setState({loading: true});
        var username = this.state.username;

        const dataSiswa = await accountManagement.get(CONFIG.CARI_DOUBLE_USERNAME+username)
        .catch(function(error) {
            console.log('kelas error '+error)
        });

        if(dataSiswa.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
            this.setState({
                dataSiswa: dataSiswa.data.data.dataSiswa
            })
        }
        this.setState({loading: false});
    }

    eksekusiReset = async (id, username)=>{
        this.setState({isFetching: true});
        console.log(id);
        console.log(username);

        const resultProses = await accountManagement.get(CONFIG.PROSES_GANTI_USERNAME+id+'&username='+username)
        .catch(function(error) {
            console.log('kelas error '+error)
        });

        if(resultProses.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
            this.setState({
                message: resultProses.data.data.message
            })
        }

        alert(resultProses.data.data.message);
        window.location.reload();

        this.setState({isFetching: false});
    }

    render() {
        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar />
                    <Row>
                        <Col sm={5}>
                            <input className="form-control" placeholder="Username" value={this.state.username} onChange={this.inputUsernameOnChange.bind(this)}></input>
                        </Col>
                        <Col sm={2}>
                            <button className="btn btn-primary" onClick={this.cariSiswa}> <li className="fa fa-search"> Goleki !</li></button>
                        </Col>
                    </Row>
                    <br></br>
                    <Row>
                        {this.loading()}
                            <Col>
                                <table className="table">
                                    <thead>
                                        <th width='10px'>No</th>
                                        <th>idSiswa</th>
                                        <th>Username</th>
                                        <th>Nama</th>
                                        <th>Kelas</th>
                                        <th>Sekolah</th>
                                        <th>Aksi</th>
                                    </thead>
                                    <tbody>
                                        {this.state.dataSiswa.map((x, i) => 
                                            <tr key={i}>
                                                <td>{i+1}.</td>
                                                <td>{x.ID_SISWA}</td>
                                                <td>{x.USERNAME_SISWA}</td>
                                                <td>{x.NAMA_SISWA}</td>
                                                <td>{x.NAMA_KELAS}</td>
                                                <td>{x.NAMA_SEKOLAH}</td>
                                                <td>                                                    
                                                    <button className="btn btn-warning" onClick={(e) => this.eksekusiReset(x.ID_SISWA, x.USERNAME_SISWA)}> 
                                                        <li className="fa fa-refresh"> Ganti</li>
                                                    </button>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </Col>
                        {this.loading()}    
                    </Row>
                </div>
            </div>
        )
    }


    loading = () =>{
        if(this.state.loading){
            return(
                <Loader />
            )
        }
    }
}
const mapStateToProps = (state) => {
    return {
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(ResetUsername)
